import { signal } from "@angular/core";

export type MergeNotificationStatus = "processing" | "complete" | "error";

export class MergeNotification {
    private _message: string;
    private _feedbacks = signal<string[]>([]);
    private _status = signal<MergeNotificationStatus>("processing");

    constructor(message: string) {
        this._message = message;
    }

    get message() {
        return this._message;
    }

    get feedbacks() {
        return this._feedbacks.asReadonly();
    }

    get status() {
        return this._status.asReadonly();
    }

    updateStatus(status: MergeNotificationStatus) {
        this._status.set(status);
    }

    addFeedback(feedback: string) {
        this._feedbacks.update(feedbacks => [...feedbacks, feedback]);
    }
}
